module.exports = __webpack_public_path__ + "static/media/dBanner2.ac8dcd9b.png";